<template>
  <div>
    <ContentPage headerText="Our Services">
      <p>
        <strong>We offer the following services:</strong>
      </p>
      <ul class="list">
        <li v-for="service in services" :key="service.slug">
          <a :href="`#${service.slug}`">{{ service.name }}</a>
        </li>
      </ul>
      <p>
        Please
        <router-link to="/contact-us/" class="underline"
          >Contact Us</router-link
        >
        for any enquiries.
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="sections">
          <div
            v-for="service in services"
            :id="service.slug"
            :key="service.slug"
            class="section"
            :class="{ 'section--match-image-height': service.matchImageHeight }"
          >
            <div class="section-text">
              <h2
                class="section-heading"
                role="button"
                tabindex="0"
                @click="openLightbox(service)"
                @keydown.enter="openLightbox(service)"
              >{{ service.name }}</h2>

              <p
                v-if="service.intro"
                class="intro"
                :class="{ 'intro--bold': service.introBold }"
              >{{ service.intro }}</p>

              <ul v-if="service.bullets && service.bullets.length" class="bullets">
                <li
                  v-for="(bullet, index) in service.bullets"
                  :key="index"
                  v-html="bullet"
                ></li>
              </ul>
            </div>

            <div class="image-card">
              <img
                class="image-card-img"
                :class="`image-card-img--${service.slug}`"
                :src="service.imgSrc"
                :alt="service.imgAltText"
                :style="{ objectPosition: service.imagePosition || 'center' }"
                @click="openLightbox(service)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <Lightbox :image="activeImage" @close="activeImage = null" />
  </div>
</template>

<script>
import services from '@/lib/services'
import ContentPage from '../partials/ContentPage.vue'
import Lightbox from '../partials/Lightbox.vue'

export default {
  name: 'our-services',
  metaInfo: {
    title: 'Services',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Door Restoration, Window Restoration, Interior Design, Preparation is Key, Pre-Painting, Shutter Restoration, Exterior Masonry and Scaffolding services across East Anglia and Greater London.'
      }
    ]
  },
  components: {
    ContentPage,
    Lightbox
  },
  data () {
    return {
      services,
      activeImage: null
    }
  },
  methods: {
    openLightbox (service) {
      this.activeImage = { src: service.imgSrc, alt: service.imgAltText }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;
}

.section {
  $gutter: 2rem;

  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-between;
  gap: $gutter;

  scroll-margin-top: 100px;

  h2 {
    font-size: 2rem;
    margin-bottom: $gutter;
  }

  .section-heading {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .intro {
    margin-bottom: 1.5rem;

    &--bold {
      font-weight: 700;
    }
  }

  .bullets {
    padding-left: 1.25rem;

    li {
      list-style: disc;
      margin-bottom: 0.75rem;
      line-height: 1.6;
    }
  }

  .image-card {
    width: 100%;
  }

  .image-card-img {
    display: block;
    width: 100%;
    height: 220px;
    object-fit: cover;
    cursor: pointer;
  }

  @media (min-width: $md-breakpoint) {
    gap: 4rem;
    flex-direction: row;

    > * {
      flex: 1;
    }

    .image-card-img {
      height: 360px;
    }

    &:nth-child(2n) {
      .section-text {
        order: 2;
      }

      .image-card {
        order: 1;
      }
    }
  }

  &--match-image-height {
    @media (min-width: $md-breakpoint) {
      align-items: stretch;

      .image-card {
        position: relative;
        align-self: stretch;
      }

      .image-card-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.list {
  display: flex;
  flex-wrap: wrap;

  margin-bottom: 30px;
  column-gap: 20px;

  li {
    width: 100%;

    @media (min-width: $xs-breakpoint) {
      width: 50%;
    }

    @media (min-width: $sm-md-breakpoint) {
      width: 33.33%;
    }

    @media (min-width: $md-breakpoint) {
      width: calc(33.33% - 20px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Services.vue